import { Box, Button, List, ListItem, Menu } from "@mui/joy";
import { useResetRecoilState } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import { userAtom, UserType } from "recoil/userAtom";
import UserProfile from "./UserProfile";
import { useNavigate } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import { sendMessage } from "utils/webview";
import React, { useEffect, useState } from "react";
import useIsInappWebview from "hooks/useIsInappWebview";
import { programDataAtom } from "recoil/programDataAtom";
import { taskListAtom } from "recoil/taskListAtom";
import { homeThoughtRecordListAtom } from "recoil/homeThoughtRecordListAtom";
import { onboardingDataState } from "../../recoil/onboardingDataAtom";
import CustomModal from "../common/CustomModal";
import useFetch from "../../hooks/useFetch";
import { UndoneIconSvg } from "../../static/image/common/SvgAssets";
import { theme } from "../../styles/theme";

export default function UserDropDownForCoach({ user }: { user: UserType }) {
  const isInappWebview = useIsInappWebview();
  const navigate = useNavigate();
  const resetUser = useResetRecoilState(userAtom);
  const resetPid = useResetRecoilState(patientAtom);
  const resetProgramData = useResetRecoilState(programDataAtom);
  const resetTaskState = useResetRecoilState(taskListAtom);
  const resetOnboardingData = useResetRecoilState(onboardingDataState);
  const resetHomeThoughtRecordState = useResetRecoilState(
    homeThoughtRecordListAtom,
  );

  const [showMenu, setShowMenu] = useState(false);
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [logoutData, fetchLogout] = useFetch({
    url: "/user/logout",
  });

  const handleLogout = async () => {
    setIsLoading(true);
    await fetchLogout();
    setIsLoading(false);
    setLogoutModalOpen(false);
    initializeUser();
  };

  const initializeUser = () => {
    resetUser();
    resetPid();
    resetProgramData();
    resetTaskState();
    resetOnboardingData();
    resetHomeThoughtRecordState();
    navigate("/coach");
    sendMessage(
      JSON.stringify({
        event: "logout",
      }),
    );
    mixpanel.reset();
  };

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      setShowMenu(false);
    };
    window.addEventListener("click", handleClick);
    return () => {
      window.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        onClick={(e) => {
          e.stopPropagation();
          setShowMenu((showMenu) => !showMenu);
        }}
      >
        <UserProfile
          nickname={user?.nickname}
          size='sm'
          // color="primary"
        />
      </Box>

      {showMenu && (
        <Box
          className="w-fit absolute z-[10] left-[10px] bottom-[110%]"
          onPointerDown={(e) => e.stopPropagation()}
        >
          <List
            orientation='vertical'
            sx={{
              width: "100px",
              borderRadius: "12px",
              overflow: "hidden",
              borderWidth: 1,
              borderColor:
              theme.vars.palette.Border.SuperWeak,
              backgroundColor:
              theme.vars.palette.Surface.Forward,
              px: 0,
              py: 0.5,
              "--List-gap": 0,
              "--ListItem-paddingY": 0,
            }}
          >
            <ListItem sx={{ p: 0 }}>
              <>
                <Button
                  size='sm'
                  variant='Plain'
                  onPointerDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.stopPropagation();
                    setLogoutModalOpen(true);
                  }}
                  sx={{
                    "--Button-gap": "12px",
                    width: "100%",
                    height: "45px",
                    fontSize: "16px",
                    fontWeight: 500,
                    pl: "20px",
                    py: "12px",
                    justifyContent: "flex-start",
                    color: theme.vars.palette.Content.Strong,
                    backgroundColor: theme.vars.palette.Surface.Forward,
                  }}
                >
                  {"로그아웃"}
                </Button>
                <CustomModal
                  open={logoutModalOpen}
                  onClose={() => setLogoutModalOpen(false)}
                  title={"정말로 로그아웃할까요?"}
                  subtitle={"모든 기기와 브라우저에서 로그아웃돼요."}
                  actions={[
                    {
                      label: "로그아웃하기",
                      onClick: handleLogout,
                      variant: "Soft",
                      color: "danger",
                      buttonProps: {
                        loading: isLoading,
                      },
                    },
                  ]}
                />
              </>
            </ListItem>
          </List>
        </Box>
      )}
      <Menu></Menu>
    </Box>
  );
}
